module.exports = __webpack_public_path__ + "img/upload_yun.a4f70fed.png";